import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { Paper, Typography, Stack, IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import UnarchiveIcon from "@mui/icons-material/Unarchive";
import "./todo.css";
import { toast } from "react-toastify";
import { deleteArchiveTodos } from "api/all.api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { postTodos } from "api/all.api";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  paddingTop: theme.spacing(3),
  borderRadius: "0",
  color: theme.palette.text.secondary,
}));

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "#F5F5F5",
  border: "2px solid #D3D3D3",
  boxShadow: 24,
  p: 4,
};

export default function ArchiveModal({ open, setOpen, archiveTodos }) {
  const handleClose = () => setOpen(false);

  const queryClient = useQueryClient();
  const addMutation = useMutation({
    mutationFn: postTodos,
    onSuccess: (data) => {
      if (data?.error) throw data.error;
      else {
        queryClient.setQueryData(["todos"], (oldTodos) => [
          ...oldTodos,
          data.todo,
        ]);
      }
    },
    onError: (err) => {
      toast.error(err);
      console.log("Error : ", err);
    },
  });
  const deleteMutation = useMutation({
    mutationFn: deleteArchiveTodos,
    onSuccess: (data, variables) => {
      if (data?.error) throw data.error;
      else {
        queryClient.setQueryData(["arvhivetodos"], (oldTodos) =>
          oldTodos?.filter((todo) => todo._id !== variables)
        );

        toast.success(data.message);
      }
    },
    onError: (err) => {
      toast.error(err);
      console.log("Error : ", err);
    },
  });

  const unarchiveMutation = useMutation({
    mutationFn: deleteArchiveTodos,
    onSuccess: (data, variables) => {
      if (data?.error) throw data.error;
      else {
        // queryClient.setQueryData(["todos"], (oldTodos) => [
        //   ...oldTodos,
        //   data.todo,
        // ]);
        queryClient.setQueryData(["arhivetodos"], () =>
          archiveTodos?.filter((todo) => todo._id !== variables._id)
        );
        addMutation.mutate(variables);

        toast.success(data.message);
      }
    },
    onError: (err) => {
      toast.error(err);
      console.log("Error : ", err);
    },
  });

  const handleDelete = (id) => {
    deleteMutation.mutate(id);
  };

  const handleUnArhive = (item) => {
    unarchiveMutation.mutate(item);
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={style}>
          <Stack
            direction="column"
            justifyContent="flex-start"
            alignItems="stretch">
            <Item className="pt-1">
              <div className="font-weight-bold">Archive To-do</div>
            </Item>

            {archiveTodos &&
              archiveTodos.map((item, index) => (
                <Item
                  key={index}
                  className="d-flex justify-content-between border">
                  <Typography
                    variant="p"
                    component="p"
                    color="black"
                    sx={{
                      fontSize: "16px",
                      display: "inline-block",
                      width: "250px",
                      textDecoration: `${
                        item.isComplete ? "line-through" : ""
                      }`,
                    }}>
                    {item.todo}
                  </Typography>

                  <div className="d-flex">
                    <IconButton
                      size="small"
                      className="pt-0"
                      onClick={() => handleUnArhive(item)}>
                      <UnarchiveIcon fontSize="small" />
                    </IconButton>
                    <IconButton
                      size="small"
                      className="pt-0"
                      onClick={() => handleDelete(item._id)}>
                      <DeleteOutlineIcon fontSize="small" />
                    </IconButton>
                  </div>
                </Item>
              ))}
          </Stack>
        </Box>
      </Modal>
    </div>
  );
}
